import React from 'react';

const NotFound = () => {
    return (
        <div className="my-5">
            <i class="fas fa-exclamation-circle fa-4x text-danger"></i>
            <h1 className="text-warning">404</h1>
            <h2>The Page You're Trying to Access is Not Found</h2>
        </div>
    );
};

export default NotFound;